import Dialog from "ui/elements/dialog/Dialog";
import {i18n} from "ui/i18n";
import Template from "ui/Template";
import Ajax from "ui/helpers/Ajax";
import ScenesList, {TYPE_ELEMENTS_SCENES} from "ui/desktop/pages/scenes-list/ScenesList";
import ImportType, {TYPE} from "ui/editor/dialogs/elements-picker/ImportType";
import elementsPickerView from 'ui/editor/dialogs/elements-picker/html/elements-picker.handlebars';
import FatalError from "ui/components/fatal-error/FatalError";
import Spinner from "ui/components/spinner/Spinner";
import {CurrentUser} from "ui/CurrentUser";

/**
 * @typedef {Object} T_ElementsPickerOptions
 * @property {function(data:T_CanvasLayerData, name:string)} [onSelect]
 */

/**
 * @type {Template}
 */
let template = null;

/**
 * Scenes Library Elements Picker
 */
export default class ElementsPicker extends Dialog {
	/**
	 * Class Constructor
	 *
	 * @param {T_ElementsPickerOptions} [options]
	 */
	constructor(options = {}) {
		super({
			title: i18n('title.pick-element'),
			autoHeight: false,
			width: 1100
		});

		if (template === null) {
			template = new Template(elementsPickerView);
		}

		/**
		 * @type {T_ElementsPickerOptions}
		 * @private
		 */
		this._options = options;

		/**
		 * @type {ScenesList}
		 * @private
		 */
		this._list = null;

		this._buildList();
	}

	/**
	 * Builds elements list
	 *
	 * @private
	 * @returns {void}
	 */
	_buildList() {
		this._list = new ScenesList({
			type: TYPE_ELEMENTS_SCENES,
			compactMode: true,
			pickerMode: true,
			pickHandler: this._loadScene.bind(this),
		});
		this.setContent(this._list);
	}

	/**
	 * Loads scene
	 *
	 * @param {string} id
	 * @returns {void}
	 * @private
	 */
	async _loadScene(id) {
		const user = CurrentUser.get();
		const type = user.isUser() ? await new ImportType().getResult() : TYPE.SOURCE;

		let sceneData;
		Spinner.show();

		try {
			sceneData = await Ajax.get(
				type === TYPE.SOURCE
					? '/scene/flatten/' + id
					: '/scene/reference/' + id
			);
		} catch (e) {
			FatalError.show(i18n('errors.http.server-issue'));
			return;
		}

		Spinner.hide();

		if (typeof this._options.onSelect === 'function') {
			this._options.onSelect(sceneData.layer, sceneData.name);
		}
	}
}
